<section class="relative bg-gradient-to-br from-gray-900 to-blue-900 text-white overflow-hidden">
  <div class="absolute inset-0 z-0">
    <div class="absolute top-0 left-0 w-1/3 h-1/3 bg-blue-500 rounded-full filter blur-3xl opacity-20 animate-pulse"></div>
    <div class="absolute bottom-0 right-0 w-1/3 h-1/3 bg-indigo-500 rounded-full filter blur-3xl opacity-20 animate-pulse"></div>
  </div>
  
  <div class="container mx-auto px-4 py-24 md:py-32 relative z-10">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div class="text-center lg:text-left">
        <div class="inline-block bg-blue-500/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
          <span class="text-sm font-medium text-blue-300">
            <i class="bx bx-cloud mr-2"></i>Enterprise Cloud Storage
          </span>
        </div>
        
        <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          Cloud <span class="text-blue-400">Storage Solutions</span>
        </h1>
        
        <p class="text-xl text-gray-300 mb-8 max-w-2xl mx-auto lg:mx-0">
          Scalable, secure, and high-performance cloud storage with enterprise-grade features. From block storage to object storage, backup solutions, and content delivery networks.
        </p>
        
        <div class="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-10">
          <a routerLink="/contact" class="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-3 px-8 rounded-lg transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl">
            Contact Us
          </a>
          <a routerLink="/contact" class="bg-transparent border-2 border-blue-500 text-blue-300 hover:bg-blue-500/10 font-semibold py-3 px-8 rounded-lg transition-all duration-300">
            Contact Sales
          </a>
        </div>
        
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl mx-auto lg:mx-0">
          <div class="flex items-center">
            <div class="bg-blue-500/20 p-3 rounded-lg mr-4">
              <i class="bx bx-check-circle text-2xl text-blue-400"></i>
            </div>
            <div>
              <div class="font-semibold">99.99% Durability</div>
              <div class="text-sm text-gray-400">Guaranteed</div>
            </div>
          </div>
          
          <div class="flex items-center">
            <div class="bg-blue-500/20 p-3 rounded-lg mr-4">
              <i class="bx bx-check-circle text-2xl text-blue-400"></i>
            </div>
            <div>
              <div class="font-semibold">Instant Scalability</div>
              <div class="text-sm text-gray-400">On-demand</div>
            </div>
          </div>
          
          <div class="flex items-center">
            <div class="bg-blue-500/20 p-3 rounded-lg mr-4">
              <i class="bx bx-check-circle text-2xl text-blue-400"></i>
            </div>
            <div>
              <div class="font-semibold">Global CDN</div>
              <div class="text-sm text-gray-400">Fast Delivery</div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="relative">
        <div class="relative z-10 rounded-2xl overflow-hidden shadow-2xl border border-gray-700">
          <img src="assets/img/storage-cloud-hero.png" alt="Storage Cloud" class="w-full h-auto object-cover">
        </div>
        
        <div class="absolute -bottom-6 -left-6 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-xl p-5 shadow-xl w-40">
          <div class="text-2xl font-bold">Block</div>
          <div class="text-sm">Storage</div>
        </div>
        
        <div class="absolute -top-6 -right-6 bg-gradient-to-br from-indigo-600 to-purple-700 rounded-xl p-5 shadow-xl w-40">
          <div class="text-2xl font-bold">Object</div>
          <div class="text-sm">Storage</div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="py-20 bg-gray-50">
  <div class="container mx-auto px-4">
    <div class="text-center mb-16">
      <div class="inline-block bg-blue-100 text-blue-800 px-4 py-1 rounded-full text-sm font-medium mb-4">
        Storage Solutions
      </div>
      <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        Choose Your <span class="text-blue-600">Storage Type</span>
      </h2>
      <p class="text-xl text-gray-600 max-w-3xl mx-auto">
        Select from our comprehensive range of cloud storage solutions designed for different use cases, from high-performance applications to long-term archival storage.
      </p>
    </div>
    
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div class="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 transform hover:-translate-y-2">
        <div class="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-hdd text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Block Storage</h3>
        <p class="text-gray-600 mb-4">
          High-performance block storage for databases, file systems, and applications requiring low-latency access and consistent IOPS.
        </p>
        <ul class="space-y-2 mb-4">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Up to 64TB per volume</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>50,000+ IOPS performance</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Snapshot capabilities</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Multi-attach support</span>
          </li>
        </ul>
        <div class="grid grid-cols-2 gap-4 mb-4">
          <div class="bg-gray-50 p-3 rounded">
            <div class="text-sm text-gray-600">Volume Size</div>
            <div class="font-semibold">1GB - 64TB</div>
          </div>
          <div class="bg-gray-50 p-3 rounded">
            <div class="text-sm text-gray-600">Performance</div>
            <div class="font-semibold">Up to 50,000 IOPS</div>
          </div>
        </div>
        <a href="#" class="text-blue-600 font-medium flex items-center hover:text-blue-800 group">
          Select Storage
          <i class="bx bx-right-arrow-alt ml-2 group-hover:translate-x-1 transition-transform"></i>
        </a>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 transform hover:-translate-y-2">
        <div class="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-cloud text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Object Storage</h3>
        <p class="text-gray-600 mb-4">
          Highly scalable object storage for web applications, content distribution, backup, and data archiving with REST API access.
        </p>
        <ul class="space-y-2 mb-4">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Unlimited scalability</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>S3-compatible API</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Lifecycle management</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>CDN integration</span>
          </li>
        </ul>
        <div class="grid grid-cols-2 gap-4 mb-4">
          <div class="bg-gray-50 p-3 rounded">
            <div class="text-sm text-gray-600">Capacity</div>
            <div class="font-semibold">Unlimited</div>
          </div>
          <div class="bg-gray-50 p-3 rounded">
            <div class="text-sm text-gray-600">Durability</div>
            <div class="font-semibold">99.999999999%</div>
          </div>
        </div>
        <a href="#" class="text-blue-600 font-medium flex items-center hover:text-blue-800 group">
          Select Storage
          <i class="bx bx-right-arrow-alt ml-2 group-hover:translate-x-1 transition-transform"></i>
        </a>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 transform hover:-translate-y-2">
        <div class="w-16 h-16 bg-gradient-to-br from-purple-500 to-violet-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-archive text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Archive Storage</h3>
        <p class="text-gray-600 mb-4">
          Cost-effective long-term storage for data archiving, compliance, and backup retention with infrequent access patterns.
        </p>
        <ul class="space-y-2 mb-4">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Lowest cost storage</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Long-term retention</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Compliance ready</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Automated tiering</span>
          </li>
        </ul>
        <div class="grid grid-cols-2 gap-4 mb-4">
          <div class="bg-gray-50 p-3 rounded">
            <div class="text-sm text-gray-600">Retrieval</div>
            <div class="font-semibold">1-12 hours</div>
          </div>
          <div class="bg-gray-50 p-3 rounded">
            <div class="text-sm text-gray-600">Retention</div>
            <div class="font-semibold">Unlimited</div>
          </div>
        </div>
        <a href="#" class="text-blue-600 font-medium flex items-center hover:text-blue-800 group">
          Select Storage
          <i class="bx bx-right-arrow-alt ml-2 group-hover:translate-x-1 transition-transform"></i>
        </a>
      </div>
    </div>
  </div>
</section>

<section class="py-20 bg-white">
  <div class="container mx-auto px-4">
    <div class="text-center mb-16">
      <div class="inline-block bg-blue-100 text-blue-800 px-4 py-1 rounded-full text-sm font-medium mb-4">
        Enterprise Features
      </div>
      <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        Cloud Storage <span class="text-blue-600">Capabilities</span>
      </h2>
      <p class="text-xl text-gray-600 max-w-3xl mx-auto">
        Advanced features and capabilities designed for enterprise workloads, high availability, and seamless integration with your existing infrastructure.
      </p>
    </div>
    
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div class="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 transform hover:-translate-y-2">
        <div class="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-shield-check text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Advanced Security</h3>
        <p class="text-gray-600 mb-4">
          Enterprise-grade security with encryption at rest and in transit, access controls, and compliance certifications for data protection.
        </p>
        <ul class="space-y-2">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>AES-256 encryption</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>IAM integration</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Access control policies</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Audit logging</span>
          </li>
        </ul>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 transform hover:-translate-y-2">
        <div class="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-data text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Automated Backup</h3>
        <p class="text-gray-600 mb-4">
          Automated backup solutions with point-in-time recovery, cross-region replication, and intelligent lifecycle management.
        </p>
        <ul class="space-y-2">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Automated snapshots</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Cross-region replication</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Point-in-time recovery</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Lifecycle policies</span>
          </li>
        </ul>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 transform hover:-translate-y-2">
        <div class="w-16 h-16 bg-gradient-to-br from-purple-500 to-violet-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-network-chart text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">High Performance</h3>
        <p class="text-gray-600 mb-4">
          Optimized for high throughput and low latency with SSD storage, intelligent caching, and global content delivery.
        </p>
        <ul class="space-y-2">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>SSD-based storage</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Intelligent caching</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Global CDN</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Multi-zone redundancy</span>
          </li>
        </ul>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 transform hover:-translate-y-2">
        <div class="w-16 h-16 bg-gradient-to-br from-orange-500 to-amber-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-trending-up text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Auto Scaling</h3>
        <p class="text-gray-600 mb-4">
          Seamlessly scale storage capacity on-demand with automatic provisioning and intelligent resource management.
        </p>
        <ul class="space-y-2">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Auto-scaling</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Elastic capacity</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Dynamic provisioning</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Resource optimization</span>
          </li>
        </ul>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 transform hover:-translate-y-2">
        <div class="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-code-alt text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">API Integration</h3>
        <p class="text-gray-600 mb-4">
          Comprehensive REST APIs, SDKs, and third-party integrations for seamless application development and deployment.
        </p>
        <ul class="space-y-2">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>RESTful APIs</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Multiple SDKs</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>S3 compatibility</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Third-party tools</span>
          </li>
        </ul>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 transform hover:-translate-y-2">
        <div class="w-16 h-16 bg-gradient-to-br from-red-500 to-rose-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-analyse text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Storage Analytics</h3>
        <p class="text-gray-600 mb-4">
          Comprehensive monitoring and analytics with usage insights, performance metrics, and cost optimization recommendations.
        </p>
        <ul class="space-y-2">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Usage analytics</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Performance monitoring</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Cost optimization</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Custom dashboards</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="py-20 bg-gray-50">
  <div class="container mx-auto px-4">
    <div class="text-center mb-16">
      <div class="inline-block bg-blue-100 text-blue-800 px-4 py-1 rounded-full text-sm font-medium mb-4">
        Application Scenarios
      </div>
      <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        Storage Cloud <span class="text-blue-600">Use Cases</span>
      </h2>
      <p class="text-xl text-gray-600 max-w-3xl mx-auto">
        Discover how our cloud storage solutions power diverse applications, from content delivery and backup to big data analytics and enterprise applications.
      </p>
    </div>
    
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div class="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 transform hover:-translate-y-2">
        <div class="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-world text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Web & Media Hosting</h3>
        <p class="text-gray-600 mb-4">
          Host websites, streaming media, and static assets with global CDN integration for fast content delivery and optimal user experience.
        </p>
        <ul class="space-y-2 mb-4">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Global CDN integration</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Static website hosting</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Media streaming support</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Edge caching</span>
          </li>
        </ul>
        <div class="flex gap-4 text-sm">
          <div class="bg-blue-500/10 px-3 py-1 rounded">
            <span class="text-blue-600 font-semibold">< 50ms</span>
            <span class="text-gray-600">Latency</span>
          </div>
          <div class="bg-blue-500/10 px-3 py-1 rounded">
            <span class="text-blue-600 font-semibold">99.9%</span>
            <span class="text-gray-600">Availability</span>
          </div>
        </div>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 transform hover:-translate-y-2">
        <div class="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-data text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Backup & Archive</h3>
        <p class="text-gray-600 mb-4">
          Secure backup and long-term archival solutions with automated retention policies, compliance features, and disaster recovery capabilities.
        </p>
        <ul class="space-y-2 mb-4">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Automated backup schedules</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Compliance retention</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Disaster recovery</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Cross-region replication</span>
          </li>
        </ul>
        <div class="flex gap-4 text-sm">
          <div class="bg-green-500/10 px-3 py-1 rounded">
            <span class="text-green-600 font-semibold">99.999%</span>
            <span class="text-gray-600">Durability</span>
          </div>
          <div class="bg-green-500/10 px-3 py-1 rounded">
            <span class="text-green-600 font-semibold">24/7</span>
            <span class="text-gray-600">Monitoring</span>
          </div>
        </div>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 transform hover:-translate-y-2">
        <div class="w-16 h-16 bg-gradient-to-br from-purple-500 to-violet-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-analyse text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Analytics & Processing</h3>
        <p class="text-gray-600 mb-4">
          Store and process large datasets for analytics, machine learning, and business intelligence with high-performance compute integration.
        </p>
        <ul class="space-y-2 mb-4">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Petabyte-scale storage</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Compute integration</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Data lake architecture</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>ML/AI workflows</span>
          </li>
        </ul>
        <div class="flex gap-4 text-sm">
          <div class="bg-purple-500/10 px-3 py-1 rounded">
            <span class="text-purple-600 font-semibold">PB</span>
            <span class="text-gray-600">Scale</span>
          </div>
          <div class="bg-purple-500/10 px-3 py-1 rounded">
            <span class="text-purple-600 font-semibold">GPU</span>
            <span class="text-gray-600">Compute</span>
          </div>
        </div>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 transform hover:-translate-y-2">
        <div class="w-16 h-16 bg-gradient-to-br from-orange-500 to-amber-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-buildings text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Enterprise Applications</h3>
        <p class="text-gray-600 mb-4">
          Support enterprise applications with high-performance block storage, database hosting, and application data management solutions.
        </p>
        <ul class="space-y-2 mb-4">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>High IOPS performance</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Database optimization</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Enterprise integrations</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Multi-attach volumes</span>
          </li>
        </ul>
        <div class="flex gap-4 text-sm">
          <div class="bg-orange-500/10 px-3 py-1 rounded">
            <span class="text-orange-600 font-semibold">50K+</span>
            <span class="text-gray-600">IOPS</span>
          </div>
          <div class="bg-orange-500/10 px-3 py-1 rounded">
            <span class="text-orange-600 font-semibold">SLA</span>
            <span class="text-gray-600">Guaranteed</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="py-20 bg-white">
  <div class="container mx-auto px-4">
    <div class="text-center mb-16">
      <div class="inline-block bg-blue-100 text-blue-800 px-4 py-1 rounded-full text-sm font-medium mb-4">
        Transparent Pricing
      </div>
      <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        Storage <span class="text-blue-600">Pricing Plans</span>
      </h2>
      <p class="text-xl text-gray-600 max-w-3xl mx-auto">
        Simple, transparent pricing with no hidden fees. Pay only for what you use with flexible billing options and volume discounts.
      </p>
    </div>
    
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
      <div class="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-xl border border-gray-200 p-8 relative overflow-hidden">
        <div class="text-center mb-6">
          <div class="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center mx-auto mb-4">
            <i class="bx bx-hdd text-3xl text-white"></i>
          </div>
          <h3 class="text-2xl font-bold text-gray-900 mb-2">Block Storage</h3>
          <div class="text-3xl font-bold text-blue-600 mb-1">₹2<span class="text-sm">/GB/month</span></div>
        </div>
        
        <ul class="space-y-3 mb-8">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>High-performance SSD</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Up to 50,000 IOPS</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Snapshot capabilities</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Multi-attach support</span>
          </li>
        </ul>
        
        <a href="#" class="block w-full bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-3 px-6 rounded-lg text-center transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl">
          Get Started
        </a>
      </div>
      
      <div class="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-xl border border-gray-200 p-8 relative overflow-hidden">
        <div class="absolute top-0 right-0 bg-gradient-to-r from-blue-600 to-indigo-700 text-white px-4 py-1 rounded-bl-lg font-bold">
          Most Popular
        </div>
        <div class="text-center mb-6">
          <div class="w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center mx-auto mb-4">
            <i class="bx bx-cloud text-3xl text-white"></i>
          </div>
          <h3 class="text-2xl font-bold text-gray-900 mb-2">Object Storage</h3>
          <div class="text-3xl font-bold text-blue-600 mb-1">₹0.50<span class="text-sm">/GB/month</span></div>
        </div>
        
        <ul class="space-y-3 mb-8">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Unlimited scalability</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>S3-compatible API</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>CDN integration</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>99.999999999% durability</span>
          </li>
        </ul>
        
        <a href="#" class="block w-full bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-3 px-6 rounded-lg text-center transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl">
          Get Started
        </a>
      </div>
      
      <div class="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-xl border border-gray-200 p-8 relative overflow-hidden">
        <div class="text-center mb-6">
          <div class="w-16 h-16 bg-gradient-to-br from-purple-500 to-violet-600 rounded-xl flex items-center justify-center mx-auto mb-4">
            <i class="bx bx-archive text-3xl text-white"></i>
          </div>
          <h3 class="text-2xl font-bold text-gray-900 mb-2">Archive Storage</h3>
          <div class="text-3xl font-bold text-blue-600 mb-1">₹0.10<span class="text-sm">/GB/month</span></div>
        </div>
        
        <ul class="space-y-3 mb-8">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Lowest cost storage</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Long-term retention</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Compliance ready</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-500 mr-2"></i>
            <span>Automated tiering</span>
          </li>
        </ul>
        
        <a href="#" class="block w-full bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-3 px-6 rounded-lg text-center transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl">
          Get Started
        </a>
      </div>
    </div>
  </div>
</section>

<section class="py-20 bg-gradient-to-br from-gray-900 to-blue-900 text-white">
  <div class="container mx-auto px-4 text-center">
    <h2 class="text-3xl md:text-4xl font-bold mb-6">
      Ready to Scale Your Storage?
    </h2>
    <p class="text-xl text-gray-300 mb-10 max-w-3xl mx-auto">
      Start with our flexible cloud storage solutions today. Get enterprise-grade features, 99.99% durability, and pay-as-you-use pricing with no upfront costs.
    </p>
    <div class="flex flex-col sm:flex-row gap-4 justify-center">
      <a routerLink="/sign-up" class="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-3 px-8 rounded-lg transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl">
        Start Free Trial
      </a>
      <a routerLink="/contact" class="bg-transparent border-2 border-blue-500 text-blue-300 hover:bg-blue-500/10 font-semibold py-3 px-8 rounded-lg transition-all duration-300">
        Contact Sales
      </a>
    </div>
  </div>
</section>